import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import styled, { css } from 'styled-components';
export var YearViewContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 300px;\n  overflow-y: auto;\n"])));
export var YearText = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  height: 40px;\n  display: flex;\n  outline: none;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  letter-spacing: 0.15008px;\n  font-weight: 400;\n  line-height: 1.75;\n  font-size: 16px;\n  font-family: ", ";\n  color: ", ";\n\n  ", ";\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.fontRegular;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.calendar.textColor;
}, function (_ref3) {
  var selected = _ref3.selected;
  return selected && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-family: ", ";\n    color: ", ";\n    font-size: 24px;\n    margin: 10px 0;\n    font-weight: 500;\n    line-height: 1.33;\n    letter-spacing: normal;\n  "])), function (_ref4) {
    var theme = _ref4.theme;
    return theme.fonts.fontSemiBold;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.calendar.selectedTextColor;
  });
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n    pointer-events: none;\n  "])), function (_ref7) {
    var theme = _ref7.theme;
    return theme.calendar.disabledTextColor;
  });
});